module.exports = __webpack_public_path__ + "img/clo_u.6d10cd4b.svg";